import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import mixpanel from "mixpanel-browser";

import Button from "components/Button";
import Tooltip from "components/Tooltip";

import { selectUserUid } from "store/users/selectors";
import {
    selectCommunityId,
    selectIsCommDataChanged,
    selectCommunityIsSavingEcmInputMap,
    selectCommunityIsSaving,
} from "store/community/selectors";
import { selectIsCommUpgradesChanged, selectIsCommUpgradesSaving } from "../Upgrades/_ducks/selectors";
import { saveUpgrades } from "../Upgrades/_ducks/thunk";
import { saveCommunity, saveEcmInputMap } from "store/community/thunk";

import Save from "assets/images/icons/JSX/save";

import classes from "./style.module.scss";

const TopButtons = ({
    currentTab,
    readOnly,
    uid,
    communityId,
    isCommunityChanged,
    isUpgradesChanged,
    isSavingEcmInputMap,
    isSavingCommunity,
    isSavingUpgrades,
    saveCommunityUpgrades,
    saveCommunityData,
    saveEcmInputMap,
}) => {
    const [isInvalid, setIsInvalid] = useState(false);

    const isSaving = isSavingEcmInputMap || isSavingCommunity || isSavingUpgrades;

    // useEffect(() => {
    //     if ((["/", ""].includes(currentTab)) && !isEmpty(community)) {
    //         if (Object.keys(community).includes("syncErrors")) { // TODO: Implement syncErrors
    //             setIsInvalid(true);
    //         }
    //         else {
    //             setIsInvalid(false);
    //         }
    //     }
    // }, [community]);

    useEffect(() => {
        if (isCommunityChanged || isUpgradesChanged) {
            const unloadCallback = (event) => {
                event.preventDefault();
                event.returnValue = "";
                return "";
            };

            window.addEventListener("beforeunload", unloadCallback);
            return () => window.removeEventListener("beforeunload", unloadCallback);
        }
    }, [isCommunityChanged, isUpgradesChanged]);

    return (
        <div className={classes.buttons}>
            <div
                className={classes.saveWrapper}
                data-for="saveTip"
                data-tip={(() => {
                    if (readOnly) {
                        return "Saving disabled in read-only mode";
                    }
                    if (isInvalid) {
                        return "Please resolve invalid fields";
                    } else if (!(isCommunityChanged || isUpgradesChanged)) {
                        return "There are no changes to save";
                    }
                })()}
            >
                <Button
                    style={{ minWidth: "9.625rem" }}
                    smallPadding
                    icon={() => <Save strokeClass={classes.saveIconStroke} />}
                    onClick={async () => {
                        // clearTimeout(saveTimeout);
                        document.body.style.cursor = "progress";
                        await saveCommunityUpgrades();
                        await saveCommunityData(uid);
                        await saveEcmInputMap(communityId); // check saving
                        document.body.style.cursor = "default";
                        mixpanel.track("Save Community");
                    }}
                    disabled={
                        isSaving ||
                        isInvalid ||
                        !(isCommunityChanged || isUpgradesChanged) ||
                        readOnly
                    }
                >
                    {isSaving ? "Saving..." : readOnly ? "Read-only" : "Save Changes"}
                </Button>
                <Tooltip
                    id="saveTip"
                    hide={!isInvalid && !readOnly && (isCommunityChanged || isUpgradesChanged)}
                />
            </div>

            <style>
                {`
              .MuiInputBase-root::before {
                border-bottom: none !important;
              }
              .MuiInput-underline.Mui-focused:after {
                border-bottom: none !important;
              }
              .Mui-selected {
                background-color: white !important;
                font-weight: bold
              }
              .MuiListItem-button:hover {
                background-color: #F0F8FD !important;
                color: #0049C6 !important;
              }
              .MuiList-root {
                padding-top: 0 !important;
                padding-bottom: 0 !important;
              }
              `}
            </style>
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    uid: selectUserUid,
    communityId: selectCommunityId,
    isCommunityChanged: selectIsCommDataChanged,
    isUpgradesChanged: selectIsCommUpgradesChanged,
    isSavingEcmInputMap: selectCommunityIsSavingEcmInputMap,
    isSavingCommunity: selectCommunityIsSaving,
    isSavingUpgrades: selectIsCommUpgradesSaving,
});

const mapDispatchToProps = (dispatch) => ({
    saveCommunityUpgrades: () => dispatch(saveUpgrades()),
    saveCommunityData: (uid) => dispatch(saveCommunity(uid)),
    saveEcmInputMap: (id) => dispatch(saveEcmInputMap(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TopButtons);
